export const getVideoPoster = (url: string) => {
  // console.log('url', url);
  let splitUrl = url.split('.');
  splitUrl.pop();
  splitUrl.push('jpeg');
  const poster = splitUrl.join('.');
  return poster;
};